import { render } from "./EditButton.vue?vue&type=template&id=57fb6e63&scoped=true"
import script from "./EditButton.vue?vue&type=script&lang=js"
export * from "./EditButton.vue?vue&type=script&lang=js"

import "./EditButton.vue?vue&type=style&index=0&id=57fb6e63&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57fb6e63"]])

export default __exports__